export const blockIconsContentHowToReg = (
	<span className='material-symbols-outlined'>how_to_reg</span>
);
